import React, { FC, useContext } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { createRandomKey } from '../../utils/jsxUtils';
import {
  buildUrlWithParameters,
  isUrlInternal,
} from '../../utils/url-utils/urlUtils';
import { UserContext } from '../../user/UserContext';
import { CommentaryHeader } from './CommentaryHeader';
import { CommentarySubtext } from './CommentarySubtext';
import { Commentary } from '../commentary.types';
import { RestrictedModalCommentaries } from '../../components/modal/components/modal-restricted/RestrictedModalCommentaries';
import { ModalContext } from '../../components/modal/ModalContext';

type Props = {
  commentary: Commentary;
  onCommentaryClicked: Function;
  source: string;
  className?: string;
  small?: boolean;
};

export const HybridCommentaryCard: FC<Props> = ({
  commentary,
  source,
  className,
  onCommentaryClicked,
  small = false,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openModal } = useContext(ModalContext);

  const handleClick = () => {
    if (accessPremium) {
      onCommentaryClicked(commentary);
    } else {
      openModal(modalProps => (
        <RestrictedModalCommentaries
          source="decision_comments"
          {...modalProps}
        />
      ));
    }
  };

  const isDoctrineLink = isUrlInternal(commentary.url);
  const commentaryLink = isDoctrineLink
    ? buildUrlWithParameters(commentary.url, { source })
    : commentary.url;
  const id = `access-limited-${createRandomKey()}`;
  return (
    <Hyperlink
      data-for={id}
      data-tip
      data-offset="{'top': -20}"
      onClick={handleClick}
      {...(accessPremium
        ? {
            href: commentaryLink,
            target: isDoctrineLink ? '' : '_blank',
            rel: isDoctrineLink ? '' : 'nofollow',
          }
        : {})}
      className={className}
    >
      <CommentaryHeader
        commentary={commentary}
        isDoctrineLink={isDoctrineLink}
        small={small}
      />
      <CommentarySubtext commentary={commentary} />
      <Tooltip effect="solid" place="top" id={id}>
        <div className="decision__comments__tooltip">
          <div>
            <FormattedMessage id="commentary/card/HybridCommentaryCard.tsx/1" />
          </div>
          <div>
            <FormattedMessage id="commentary/card/HybridCommentaryCard.tsx/2" />{' '}
            {commentary.sourceName}
          </div>
        </div>
      </Tooltip>
    </Hyperlink>
  );
};
